import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { title: "Sales" }, {
    default: _withCtx(() => [
      _createVNode(_component_DataTable, {
        loading: _ctx.loading == 'loading',
        data: _ctx.items.data,
        columns: _ctx.fields,
        pagination: _ctx.items,
        onEdit: _ctx.editRecord,
        onFilter: _ctx.filterRecord,
        onCreate: _ctx.createRecord
      }, null, 8, ["loading", "data", "columns", "pagination", "onEdit", "onFilter", "onCreate"])
    ]),
    _: 1
  }))
}